import { Injectable } from '@angular/core';
import { RolePermission } from './permission.model';
import { FormKey } from './form-keys';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private permissions: RolePermission[] = [];

  constructor() {}

  setPermissions(data: RolePermission[]) {
    this.permissions = data;
  }

  getPermission(formKey: FormKey): RolePermission | undefined {
    return this.permissions.find(p => p.formKey === formKey);
  }

  canRead(formKey: FormKey): boolean {
    return this.getPermission(formKey)?.canRead ?? false;
  }

  canCreate(formKey: FormKey): boolean {
    return this.getPermission(formKey)?.canCreate ?? false;
  }

  canUpdate(formKey: FormKey): boolean {
    return this.getPermission(formKey)?.canUpdate ?? false;
  }

  canDelete(formKey: FormKey): boolean {
    return this.getPermission(formKey)?.canDelete ?? false;
  }
}